// extracted by mini-css-extract-plugin
export default {"section":"PaperSubmission_section__ozD-G","container":"PaperSubmission_container__e-yeJ","format":"PaperSubmission_format__voFki"};